<template lang="html">
	<svg
		viewBox="0 0 515.555 515.555" 
		xmlns="http://www.w3.org/2000/svg">
		<path d="m303.347 18.875c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
		<path d="m303.347 212.209c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
		<path d="m303.347 405.541c25.167 25.167 25.167 65.971 0 91.138s-65.971 25.167-91.138 0-25.167-65.971 0-91.138c25.166-25.167 65.97-25.167 91.138 0"/>
	</svg>
</template>

<script>
export default {
  name: 'DottedMenu'
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/icons/DottedMenu.vue